<template>
    <div class="blog-edit-wrapper">
        <div class="row">
            <div class="col-12">
                <div class="card blog-edit-wrapper">
                    <div class="card-body">
                        <div class="row mt-2">
                            <div class="col-md-4 col-12">
                                <div class="form-group mb-2">
                                    <label for="blog-edit-title">Title</label>
                                    <b-form-input
                                        id="blog-edit-title"
                                        v-model="blogTitle"
                                        placeholder="Blog Title"
                                    />
                                </div>
                            </div>
                            <div class="col-md-4 col-12">
                                <div class="form-group mb-2">
                                    <label for="blog-edit-category">Category</label>
                                    <v-select
                                        id="blog-edit-category"
                                        v-model="category"
                                        :options="categories"
                                    />
                                </div>
                            </div>
                            <div class="col-md-4 col-12">
                                <div class="form-group mb-2">
                                    <label for="blog-edit-type">Type</label>
                                    <v-select
                                        id="blog-edit-type"
                                        v-model="post_type"
                                        :options="postTypes"
                                        :reduce="type => type.id"
                                    />
                                </div>
                            </div>
                            <div class="col-md-6 col-12">
                                <div class="row">
                                    <div class="form-group mb-2 col-md-12 col-12">
                                        <label for="blog-edit-tags">Tags</label>
                                        <v-select
                                            id="blog-edit-tags"
                                            v-model="selectedTags.value"
                                            multiple
                                            :options="tags"
                                        />
                                    </div>
                                    <div class="form-group mb-2 col-lg-6 col-sm-12">
                                        <label for="blog-edit-notification">Send Notification</label>
                                        <v-select
                                            id="blog-edit-notification"
                                            v-model="selectedNotification"
                                            :options="notifications"
                                            :reduce="notification => notification.id"
                                            placeholder="Send Notification"
                                        />
                                    </div>
                                    <div class="form-group mb-2 col-md-6 col-sm-12">
                                        <label for="blog-edit-status">Status</label>
                                        <v-select
                                            id="blog-edit-status"
                                            v-model="status"
                                            :options="statusOption"
                                            :reduce="status => status.id"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 mb-2  col-sm-12">
                                <div class="border rounded p-2">
                                    <h4 class="mb-1">Featured Image</h4>
                                    <div class="media flex-column flex-md-row">
                                        <img :src="file" id="blog-feature-image preview" class="rounded mr-2 mb-1 mb-md-0" width="170" height="110" alt="Blog Featured Image" v-if="file"/>
                                        <img :src="settingStore.creditfixrrBanner" id="blog-feature-image preview" class="rounded mr-2 mb-1 mb-md-0" width="170" height="110" alt="Blog Featured Image" v-else/>
                                        <div class="media-body">
                                            <small class="text-muted">Required image resolution 800x400, image size 10mb.</small>
                                            <p class="my-50">
                                                <a href="javascript:void(0);" id="blog-image-text">C:\fakepath\banner.jpg</a>
                                            </p>
                                            <div class="d-inline-block">
                                                <div class="form-group mb-0">
                                                    <div class="custom-file">
                                                        <input type="file" class="custom-file-input" id="blogCustomFile" accept="image/*" data-toggle="modal" data-target="#larger" @change="selectedImg" enctype="multipart/form-data"/>
                                                        <label class="custom-file-label" for="blogCustomFile">Choose file</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group mb-2">
                                    <label>Content</label>
                                    <div id="blog-editor-wrapper">
                                        <div id="blog-editor-container">
                                        <editor
                                            v-model="editorContentRef"
                                            :api-key="settingStore.tinymce.api_key"
                                            :init="settingStore.tinymce.configuration"
                                        />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 mt-50">
                                <button @click="submitPost" class="btn btn-primary mr-1">
                                    {{ status == _.head(statusOption).id ? 'Save as Draft' : 'Publish update' }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade text-left show" id="larger" tabindex="-1" aria-labelledby="myModalLabel17" style="padding-right: 15px;" aria-modal="true" role="dialog">
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div class="modal-body">
                    <cropper
                        v-if='img'
                        class="cropper"
                        :src="img"
                        :stencil-props="{
                        aspectRatio: 4/2
                        }"
                        @change="change"
                    />
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary waves-effect waves-float waves-light" data-dismiss="modal">Accept</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {BFormInput} from 'bootstrap-vue-3'
// import 'vue-select/dist/vue-select.css';

import Editor from '@tinymce/tinymce-vue'
import { Cropper } from 'vue-advanced-cropper'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import { ref, reactive } from 'vue'
import 'vue-advanced-cropper/dist/style.css';
import 'vue-select/dist/vue-select.css';
import { useSettingStore } from '../../stores/SettingStore.js'
export default {
    components: {
        vSelect,
        editor:Editor,
        Cropper,
        BFormInput,
    },
    directives: {
        Ripple,
    },
    setup() {
        return {
            category: ref('creditfixrr'),
            categories: [
                'New Features',
                'Improved Features',
                'Fixed Features',
                'creditfixrr',
                'fcra',
                'dcpa',
                'metro2',
                'compliance',
                'dispute',
                'credit repair tips',
                'credit repair laws',
                'cfpb',
                'credit repair',
                'Credit Repair',
                'e-oscar',
                'FCRA',
                'FDCPA',
                'TILA',
                'CFPB',
                'BBB',
                'Creditfixrr',
                'Consumer Laws',
                'Credit Repair Tips',
                'Dispute Strategies'
            ],
            selectedNotification: ref(0),
            notifications:[
                {
                    id: 0,
                    label: 'Off',
                },
                {
                    id: 1,
                    label: 'Self Users',
                },
                {
                    id: 2,
                    label: 'Family Users',
                },
                {
                    id: 3,
                    label: 'Business Users',
                },
                {
                    id: 4,
                    label:'All Users',
                }
            ],
            post_type: ref(1),
            postTypes: [
                {
                    id: 1,
                    label: 'Blog'
                },
                {
                    id: 2,
                    label: 'Feature'
                }
            ],
            selectedTags: reactive({value:['creditfixrr']}),
            status: ref(1),
            statusOption: [
                {
                    id: 0,
                    label: 'Draft'
                },
                {
                    id: 1,
                    label: 'Publish'
                }
            ],
            tags:['New','Improved','Fixed','creditfixrr',],
            tags: [
                'New',
                'Improved',
                'Fixed',
                'creditfixrr',
                'credit',
                'fixer',
                'Credit Repair',
                'Dispute'
            ],
            blogTitle: ref(null),
            randomId: ref(null),
            slug: ref(null),
            img: ref(null),
            file: ref(null),
            editorContentRef: ref(null),
            settingStore: useSettingStore(),
            _: _,
        }
    },
    mounted(){
        this.editData();
    },
    created() {
    },
    computed: {
    },
    methods: {
        selectedImg(e) {
            e.preventDefault()
            const file = e.target.files[0];
            this.img = URL.createObjectURL(file);
        },
        submitPost() {
            let updateData = {
                blogtitle: this.blogTitle,
                category: this.category,
                randomId: this.randomId,
                slug: _.kebabCase(this.blogTitle),
                status: this.status,
                blobImage:this.file,
                blogdetails: this.editorContentRef,
                seotags: this.selectedTags.value,
                post_type:this.post_type,
                user_to_notify: this.selectedNotification
            }
            let $this = this;
            const route = this.$router.resolve(
                {
                    name: 'blog-update'
                }
            );
            axios.post(route.href,updateData).then(({data})=>{
                toastr.success(data.message, 'success!');
                $this.$router.push({ name: 'blogs' });
            }).catch((error)=>{
                toastr.error("All blog fields are required, please check if you've fill all the fields", 'error!');
            })
        },
        async editData(){
            let $this = this;
            const route = this.$router.resolve(
                {
                    name: 'post-edit',
                    params: {
                        category: this.$route.params.category,
                        slug: this.$route.params.slug,
                    },
                }
            );
            await axios.get(route.href).then(({data})=>{

                let Data = data.data
                $this.blogTitle = Data.blogtitle;
                $this.slug = Data.slug
                $this.category = Data.category
                let newtags = Data.seotags.split(',')
                $this.selectedTags.value = newtags
                $this.editorContentRef = Data.blogdetails
                $this.post_type = Data.post_type;
                $this.status = Data.published ? 1 : 0;
                $this.randomId = Data.randomId;
                if($this.file == null){
                    $this.file = Data.blobImage
                }
            }).catch();
        },
        change({ coordinates, canvas }) {
            this.file = canvas.toDataURL();
        }
    },
}
</script>

<style lang="scss">
@import '../../../sass/vue/pages/page-blog.scss';
</style>
